/**
* @name: header-left-set
* @author: weiyong
* @date: 2023-11-21 23:35
* @description：header-left-set
* @update: 2023-11-21 23:35
*/
<template>
  <div :class="prefixCls" class="themeAttr-item" v-if="!userSetting">
    <span class="themeAttr-item-title">{{t('头部左侧设置')}}</span>
    <div class="themeAttr-item-body w100b flex-div">
      <div class="switch-item" >
        <div class="switch-label">{{t('显示系统标题')}}</div>
        <a-switch @change="(checked)=>{change(HandlerEnum.HEADER_SYSTEM_TITLE,checked)}"  v-model:checked="getShowSystemTitle" />
      </div>

      <div class="switch-item" v-if="!userSetting">
        <div class="switch-label">{{t('显示系统Logo')}}</div>
        <a-switch @change="(checked)=>{change(HandlerEnum.SHOW_LOGO,checked)}"  v-model:checked="getShowLogo" />
      </div>


    </div>

  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "header-left-set",
});
</script>

<script lang="ts" setup>
import {Switch as ASwitch} from "ant-design-vue";
import {useDesign} from "@/hooks/web/useDesign";
import {baseHandler} from "@/layouts/default/setting/handler";
import {HandlerEnum} from "@/layouts/default/setting/enum";
import {useI18n} from "vue-i18n";
import {useHeaderSetting} from "@/hooks/setting/useHeaderSetting";
import {useRootSetting} from "@/hooks/setting/useRootSetting";

const {
  getShowSystemTitle
} = useHeaderSetting();

const { getShowLogo } = useRootSetting();

const { t } = useI18n();
interface IProps{
  useLayout:string,
  userSetting:boolean
}
const props=withDefaults(defineProps<IProps>(),{
  userSetting:false,
  useLayout:'defaultFrame'
})


const {prefixCls} = useDesign('header-left-set');

const change=function (event,val){
  baseHandler(event, val)
}
</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-header-left-set';

.@{prefix-cls} {
  width: 100%;
  padding: 16px;
  margin-bottom: 10px;
  border-radius: 6px;
  background: #fff;
  font-family: PingFangSC-Semibold,PingFang SC;

  .switch-item{
    width:33.33%;
    margin-bottom: 12px;
  }
  .switch-label{
    margin-bottom: 8px;
  }
  .themeAttr-item-body{
    flex-wrap: wrap;
  }
  .themeAttr-item-title {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #111;
    margin-bottom: 14px;
  }
  .itme-title-span{
    text-align: center;
    margin-top: 6px;
  }
  .item-type-sign {
    width: 56px;
    height: 56px;
    padding: 3px;
    border: 1px solid #fff;
    border-radius: 3px;
    margin-right: 12px;
  }
}
.sel-icon-color{
  .color-div{
    height:30px;
    border-radius: 4px;
    cursor:pointer;
  }
  .layoutItem-type-sign-icon{
    display: none;
  }
}
</style>
